module.exports = __webpack_public_path__ + "assets-cabinet/img/help.cb40003b.svg";